import React, { useState } from "react";
import "./Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../../assets/logo.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { name: "Home", id: "hero" },
    { name: "About", id: "about" },
    { name: "Services", id: "services" },
    { name: "Portfolio", id: "portfolio" },
    { name: "Why Choose Us", id: "why-choose-us" },
    { name: "Products", id: "products" },
    { name: "Contact", id: "contact" }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);

    if (!element) return;

    const navbarHeight = 0; // Adjust according to your navbar height

    const offsetPosition =
      element.offsetTop - navbarHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });

    setMenuOpen(false);
  };

  return (
    <nav className="agency-navbar">
      <div className="container">

        <div className="navbar-wrapper">

          {/* Logo */}

          <div
            className="logo"
            onClick={() => scrollToSection("hero")}
          >
            <img
              src={logo}
              alt="Gangs N Gangs"
            />
          </div>

          {/* Navigation */}

          <ul className={`menu ${menuOpen ? "active" : ""}`}>

            {navLinks.map((item) => (
              <li
                key={item.id}
                onClick={() => scrollToSection(item.id)}
              >
                {item.name}
              </li>
            ))}

          </ul>

          {/* Contact Button */}

          <div></div>

          {/* <button
            className="btn-contact"
            onClick={() => scrollToSection("contact")}
          >
            Get Started
          </button> */}

          {/* Mobile Toggle */}

          <div
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>

        </div>

      </div>
    </nav>
  );
}